import { useEffect, useState } from 'react';
import { apiClient } from '../utils/apiClient';

interface AuthValidationState {
  isValidating: boolean;
  isValid: boolean;
  error: string | null;
}

export const useAuthValidation = () => {
  const [state, setState] = useState<AuthValidationState>({
    isValidating: true,
    isValid: false,
    error: null,
  });

  const validateToken = async (): Promise<void> => {
    const token = localStorage.getItem('accessToken');
    const user = localStorage.getItem('user');

    // Si no hay token o usuario, no es válido
    if (!token || !user) {
      setState({
        isValidating: false,
        isValid: false,
        error: null,
      });
      return;
    }

    try {
      // Validar el token con la API (o mock)
      await apiClient.get('/auth/profile');

      // Validar que el usuario en localStorage es válido
      const userData = JSON.parse(user);

      if (userData && userData.id && userData.name && userData.role) {
        // Token y usuario válidos
        setState({
          isValidating: false,
          isValid: true,
          error: null,
        });
      } else {
        throw new Error('Datos de usuario inválidos');
      }
    } catch (error) {

      // Limpiar tokens inválidos
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');

      setState({
        isValidating: false,
        isValid: false,
        error: error instanceof Error ? error.message : 'Token inválido',
      });
    }
  };

  const logout = (): void => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    setState({
      isValidating: false,
      isValid: false,
      error: null,
    });
  };

  useEffect(() => {
    void validateToken();
  }, []);

  return {
    ...state,
    validateToken,
    logout,
  };
};
